module.exports = __webpack_public_path__ + "img/transfer_hover_f48a58a.png";